<template>
  <div class="autoPlayEnd">
<!--    <div class="title">자동재생이 종료되었습니다.</div>-->
    <div class="obj">
      <ul>
        <li class="preImg" v-if="playEndPlayListStatus === 'all'" @click.prevent="exitPopup('prev')">
          <div class="img" v-if="contentInfo.prevepisode.image !== ''">
            <img :src="'https://'+contentInfo.prevepisode.image">
          </div>
          <div class="text" v-if="contentInfo.prevepisode.episodenumber !== ''">이전회차 {{contentInfo.prevepisode.episodenumber}}회</div>
          <div class="text" v-else-if="contentInfo.prevepisode.episodenumber === ''">이전회차</div>
        </li>
        <li class="rePlay" @click.prevent="exitPopup('replay')">
          <div class="rePlayIc"></div>
          <div class="text01">다시보기</div>
        </li>
        <li class="nextImg" v-if="playEndPlayListStatus === 'all' || playEndPlayListStatus === 'next'" @click.prevent="exitPopup('next')">
          <div class="img" v-if="contentInfo.nextepisode.image !== ''">
            <img :src="'https://'+contentInfo.nextepisode.image">
          </div>
          <div class="text" v-if="contentInfo.nextepisode.episodenumber !== ''">다음회차 {{contentInfo.nextepisode.episodenumber}}회</div>
          <div class="text" v-else-if="contentInfo.nextepisode.episodenumber === ''">다음회차</div>
        </li>
        <li class="nextImg" v-if="playEndPlayListStatus ==='prev'" @click.prevent="exitPopup('prev')">
          <div class="img" v-if="contentInfo.prevepisode.image !== ''">
            <img :src="'https://'+contentInfo.prevepisode.image">
          </div>
          <div class="text" v-if="contentInfo.prevepisode.episodenumber !== ''">이전회차 {{contentInfo.prevepisode.episodenumber}}회</div>
          <div class="text" v-else-if="contentInfo.prevepisode.episodenumber === ''">이전회차</div>
        </li>
      </ul>
    </div>
    <div class="close" @click.prevent="exitPopup('close')"></div>
    <div class="dim"></div>
  </div>
</template>

<script>
export default {
  name: 'PlayEndPlayList',
  props: {
    contentInfo: {
      type: Object
    },
    streamingInfo: {
      type: Object
    },
    playEndPlayListStatus: {
      type: String
    },
    exitPlayEndPlayListPopup: {
      type: Function
    }
  },
  methods: {
    exitPopup (selectMenu) {
      this.exitPlayEndPlayListPopup(selectMenu)
    }
  }
}
</script>

<style>
  .autoPlayEnd { position: absolute; top:40px; left:0px;  width: 100%;   height: 225px;   z-index: 1999;  }
  .autoPlayEnd .title {position: absolute; top:40px; left:0px; width: 100%; text-align: center; font-size: 20px; color: #ffffff; z-index: 1}
  .autoPlayEnd .obj { position: absolute; top:88px; left:0px; width: 100%; z-index: 1;  }
  .autoPlayEnd .obj ul { text-align:center;}
  .autoPlayEnd .obj li { display:inline-block; margin-right: 10px;width: 100px;   height: 55px;}
  .autoPlayEnd .obj li:last-child { margin-right: 0}
  .autoPlayEnd li .text { margin: 8px 0 0 0}

  .autoPlayEnd .rePlay{font-size: 12px; color: #ffffff;}
  .autoPlayEnd .rePlay .rePlayIc{ background: url(../../assets/images/ic_player_replay.png) no-repeat; width: 30px; height: 30px; background-size: 100% 100%;background-position: center 0; display: inline-block;}
  .autoPlayEnd .preImg{width: 100px; height:55px; font-size: 12px; color: #ffffff;}
  .autoPlayEnd .preImg img { width: 100px; height:55px; border: 1px solid #fff }
  .autoPlayEnd .nextImg{width: 100px; height:55px; font-size: 12px; color: #ffffff; }
  .autoPlayEnd .nextImg img { width: 100px; height:55px; border: 1px solid #fff }
  .autoPlayEnd .close { position: absolute; top:10px; left:355px; background: url(../../assets/images/ic-popup-close.png) no-repeat; width: 24px; height: 24px; background-size:100% 100%; z-index: 1}
</style>
